import React from "react";
import {
  Container,
  Typography,
  Paper,
  Card,
  CardContent,
  CardActions,
  Button,
  Grid2 as Grid,
} from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

const ReportsPage: React.FC = () => {
  const { user } = useAuth();

  const reports = [
    {
      id: 1,
      name: "Course Attendance",
      description: "View attendance records for all courses",
    },
    {
      id: 2,
      name: "User Activity",
      description: "Analyze user engagement and activity",
    },
    {
      id: 3,
      name: "Course Feedback",
      description: "Review feedback submitted by course participants",
    },
  ];

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Welcome, {user?.firstName}. Access and generate reports here.
      </Typography>
      <Grid container spacing={3}>
        {reports.map((report) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={report.id}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {report.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {report.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small">Generate Report</Button>
                <Button size="small">View History</Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ReportsPage;
